module.exports = __webpack_public_path__ + "img/alliancecap.a021bca2.png";